import { LearnersReliefListingsApplication } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  school_name: string
  relief_listing_title: string
  learners_relief_listing_id: string
  listing_profile_options: Array<SelectOption<string> & { disabled: boolean }>
}

export const useNewProps = () => useProps<NewProps>()

export type ShowProps = {
  relief_listing_title: string
  school_name: string
}

export const useShowProps = () => useProps<ShowProps>()

export type EditProps = {
  application: LearnersReliefListingsApplication
}
export const useEditProps = () => useProps<EditProps>()
